import { resolveEnv } from '@speeki/frontend-utils';

export const REACT_APP_APP_DOMAIN = resolveEnv(
    'REACT_APP_APP_DOMAIN',
    'https://report.master.dev.speeki.cloud',
);

export const GUEST_USER_ID = 'GUEST_USER';

/* eslint-disable sort-keys-custom-order-fix/sort-keys-custom-order-fix */
export const breakpoints = {
    xxs: 375,
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1199,
    xl: 1399,
};
/* eslint-enable sort-keys-custom-order-fix/sort-keys-custom-order-fix */

export const INITIAL_LIST_SIZE = 10;

export const CONTAINER_WIDTH = 1140;
export const CONTAINER_SIDE_PADDINGS: Record<
    keyof typeof breakpoints | 'default',
    number
> = {
    default: 48,
    lg: 48,
    md: 24,
    sm: 16,
    xl: 48,
    xs: 16,
    xxs: 16,
};
export const CONTAINER_PADDING = (
    breakpoint: keyof typeof CONTAINER_SIDE_PADDINGS,
) => CONTAINER_SIDE_PADDINGS[breakpoint] * 2;

export const MAX_FILE_SIZE_MB = 50;
export const MAX_REQUEST_FILES_SIZE_MB = 200;

export const IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'heif'];

export const VIDEO_FORMATS = ['mp4', 'mov', 'wmv', 'flv', 'qtff', 'avi'];

export const AUDIO_FORMATS = ['mp3', 'aac', 'm4a', 'amr'];

const DOCUMENTS_FORMAT = [
    'doc',
    'docx',
    'docm',
    'dotm',
    'dotx',
    'odt',
    'ods',
    'rtf',
    'pdf',
    'pptx',
    'ppt',
    'potx',
    'xps',
    'txt',
    'csv',
    'xlsx',
    'xls',
];

export const ALL_FORMATS = [
    ...IMAGE_FORMATS,
    ...VIDEO_FORMATS,
    ...AUDIO_FORMATS,
    ...DOCUMENTS_FORMAT,
];

export const ACCEPTED_FORMATS = ALL_FORMATS.map((format) => `.${format}`).join(
    ', ',
);

export const DEFAULT_URL_PREFIX = 'portal';

export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.exec(
            window.location.hostname,
        ),
);
